// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__17okL","clinicsSelect":"TableHeading_clinicsSelect__3-Ape"};